import { Markdown } from '@frontendmentorio/design-system-v2';

export default function RetrospectivePreview({ solution }) {
  const { questions, retrospective = {} } = solution;

  if (!Object.values(retrospective).join('')) {
    return questions ? <Markdown>{questions}</Markdown> : null;
  }

  const { reflections, challenges, assistance } = retrospective;

  return (
    <Markdown
      componentMap={{
        h3: ({ node, ...props }) => (
          <span {...props} className="font-semibold" />
        ),
      }}
    >
      {[
        reflections &&
          `### What are you most proud of, and what would you do differently next time?\n${reflections}`,
        challenges &&
          `### What challenges did you encounter, and how did you overcome them?\n${challenges}`,
        assistance &&
          `### What specific areas of your project would you like help with?\n${assistance}`,
      ].join('\n\n')}
    </Markdown>
  );
}
